let bootstrapLoadPromise: Promise<void> | null = null;

export function loadBootstrapStyles(): Promise<void> {
  if (!bootstrapLoadPromise) {
    bootstrapLoadPromise = import("bootstrap/dist/css/bootstrap.min.css")
      .then((): void => undefined)
      .catch((err) => {
        bootstrapLoadPromise = null;
        throw err;
      });
  }
  return bootstrapLoadPromise;
}
